export const USER_LOGIN_API = "user/userLogin";
export const CREATE_NEW_COMPANY = "company/createNewCompany";
export const ADMIN_UPDATE_COMPANY = "company/updateCompany";
export const FETCH_COMPANY_LIST = "company/companyList";
export const FETCH_HIERARCHY = "hierarchy";
export const FETCH_USER_LIST = "user/userListForAdmin";
export const FETCH_BILLING_LIST = "company/companyBillingList";
export const UPDATE_COMPANY_PAID_STATUS = "company/updateCompanyPaidStatus";
export const UPDATE_COMPANY_STATUS = "company/updateCompanyStatus";
export const ADD_COMPANY_BY_ADMIN = "company/";
export const RESET_PASSWORD = "user/resetPassword";
export const FORGOT_PASSWORD = "user/forgotPassword";
export const CHANGED_PASSWORD = "user/changePassword";
export const VERIFY_EMAIL = "user/verifyEmail";
export const RESEND_VERIFICATION_CODE = "user/resendVerificationCode";
export const USER_DETAIL = "user/getUserDetail";
export const USER_NOTIFICATIONS = "notifications";
export const NOTIFICATIONS = "notifications";
export const SEEN_NOTIFICATION = "notifications/seen";
export const CLEAR_ALL_NOTIFICATIONS = "notifications/clear-all";
export const CLEAR_NOTIFICATIONS_FOR_WINWIRE_MESSAGE =
  "notifications/clear-notifications-for-winwire-message";
export const FETCH_COMPANIES_USERS = "user/company-users";
export const USERS_WITH_INPUT_KPI_PERMISSION = "user/input-own-kpi-users";
export const USER_PROFILE_PICTURE = "user/profile-picture/";
export const USER = "user";
export const USER_PROFILE = "user/userProfile";
export const DATE_FORMAT = "company/dateFormats";
export const UPDATE_DATE_FORMAT = "company/updateDateFormat";
export const UPDATE_WORKING_DAYS = "company/updateWorkingDays";
export const USER_ROLES = "user/user-roles";
export const COMPANY_USERS = "user/getAllCompanyUserList";
export const USER_CONFIGS = "user/user-configs";
export const QUOTA_PERIODS = "user/quota-periods";
export const USER_SIGNUP_URL = "user/signup";
export const SNAPSHOT = "company/snapshot";
export const UPLOAD_BULK_IMPORT_CSV = "user/upload-bulk-import-csv";
export const VALIDATE_BULK_IMPORT = "user/validate-bulk-import";
export const USERS_BULK_IMPORT = "user/bulk-import";
export const UPDATE_USER_SESSION = "user/update-session";
export const LOGOUT = "user/logout";
export const GET_REPORTS_TO_USERS = "user/users-reports-to";
export const GET_USER_CELEBRATION_DATE = "user/get-latest-celebration-details";
export const UPDATE_USER_CELEBRATION_DATE = "user/update-celebration-date";

// REVENUE
export const USER_REVENUE = "revenue/revenue-gauge";
export const CREATE_USER_REVENUE = "revenue/submit-revenue";
export const UPDATE_REVENUE_RECORD = "revenue/update";
export const DELETE_REVENUE_RECORD = "revenue/delete";
export const RESTORE_REVENUE_RECORD = "revenue/restore";
export const GET_LEDGER_DATA_FOR_PERIOD = "revenue/get-ledger-data-for-period";

// SUBSCRIPTION
export const SUBSCRIPTION = "subscription";
export const FETCH_SUBSCRIPTION_PLANS = "subscription/plans";
export const SUBSCRIPTION_SELF_SERVE = "subscription/create";
export const UPGRADE_SUBSCRIPTION = "subscription/upgrade";
export const CONTACT_SALES_TEAM = "subscription/contactSales";
export const SUBSCRIPTION_DETAILS = "subscription/details";

// TEAMS
export const TEAMS = "team";
export const UNASSIGNED = "Unassigned";
export const DELETE_COMPANY = "user/company/";
export const CHECK_TOKEN_EXPIRY = "user/checkTokenExpiry/";
export const TEAM_MEMBER = "user/teamMember";

// KPIS
export const FETCH_KPI_TEMPLATES = "kpis/templates";
export const FETCH_ALL_KPI_TEMPLATES = "kpis/templates";
export const FETCH_SINGLE_KPI_TEMPLATE = "kpis/templates";
export const CREATE_KPI_TEMPLATES = "kpis/templates";
export const CREATE_KPI_TEMPLATE = "kpis/create-kpi-template";
export const FETCH_KPI_ACTIVITIES = "kpis/kpi-activities";
export const ASSIGN_KPI_TO_USER = "kpis/assign-template";
export const USERS_KPIS = "kpis/user-kpis";
export const FETCH_USER_DAILY_KPIS = "kpis/kpi-points";
export const USER_KPI_ENTRY = "kpis/update-daily-kpis";
export const GET_USER_KPIS = "kpis/get-daily-kpis-for-user";
export const REMOVE_KPI = "kpis/templates/";
export const UPDATE_PREVIOUS_KPI = "kpis/update-previous-daily-kpis";
export const FILTER_PARAMS = "kpis/filter-params";
export const WEEKLY_TOTALS = "kpis/weekly-totals";
export const PERFORMANCE = "kpis/performance";
export const PERFORMANCE_ANALYTICS = "kpis/performance-analytics";
export const ADD_KPI = "kpis/kpi-activities";
export const UPDATE_KPI = "kpis/kpi-activities";
export const DELETE_KPI = "kpis/delete-kpi-activities";
export const MERGE_KPI = "kpis/merge-kpi-activities";
export const RESTORE_KPI = "kpis/restore-kpi-activities";
export const COPY_TEMPLATE = "kpis/copy-template";
export const UPDATE_SORT_ORDER = "kpis/update-sort-order";
export const FETCH_FUNNEL_DATA = "kpis/getDataForConversionFunnel";
export const SAVE_CONVERSION_FUNNEL = "kpis/saveConversionFunnel";
export const SAVE_CONVERSION_FUNNEL_AS = "kpis/saveConversionFunnelAs";
export const GET_FUNNEL_ACCESS_LIST_OPTIONS = "user/getFunnelAccessListOptions";
export const GET_TROPHY_CABINET_CONTENT = "user/get-trophy-cabinet-content";
export const GET_USER_TROPHY_CABINET_DATA = "user/get-user-trophy-cabinet-data";
export const UPDATE_CUSTOM_BADGES = "user/update-custom-badges";
export const GET_CUSTOMIZE_BADGE_DATA = "user/get-customize-badge-data";
export const GET_ALL_UNSEEN_BADGES = "user/get-unseen-badges-for-user";
export const SET_BADGES_SEEN = "user/set-seen-badges";
export const UPDATE_CONVERSION_FUNNEL = "kpis/updateConversionFunnel";
export const GET_FUNNEL_BY_ID = "kpis/getConversionFunnelById";
export const GET_DEFAULT_CONVERSION_FUNNEL = "kpis/getDefaultConversionFunnel";
export const UPDATE_CONVERSION_FUNNEL_ACCESS_LIST = "kpis/updateFunnelAccessList";
export const GET_FUNNEL_LOAD_OPTIONS = "user/getFunnelLoadOptions";
export const CHECK_IF_FUNNEL_NAME_IS_UNIQUE = "kpis/validateFunnelTitle";
export const FETCH_KPI_CATEGORIZATION = "kpis/fetchKpiCategorization";
export const FETCH_KPI_CATEGORIES = "kpis/fetchKpiCategories";
export const UPDATE_KPI_ACTIONS = "kpis/updateKpiActions";
export const UPDATE_KPI_SUB_CATEGORIES = "kpis/updateKpiSubCategories";
export const UPDATE_DAILY_GOALS = "kpis/updateUserDailyGoals";
export const CHECK_IF_KPI_TEMPLATE_NAME_IS_UNIQUE = "kpis/validateTemplateName";
export const ASSIGN_KPI_TEMPLATE = "kpis/assign-kpi-template-to-user";
export const GET_USER_STREAK_DATA = "kpis/get-user-streaks";
export const GET_STREAK_CALENDAR_DATA = "kpis/get-streak-calendar-data";

// COMPANY SETTINGS
export const GET_SINGLE_COMPANY = "company/";
export const UPDATE_SINGLE_COMPANY = "company/";
export const ADMIN_DELETE_COMPANY = "company/";
export const GET_SUBSCRIPTION_OF_COMPANY = "company/companySubscriptionDetail/";
export const UPDATE_SUBSCRIPTION_OF_COMPANY = "company/updateSubscriptionTime/";
export const UPDATE_COMPANY_CALENDAR = "company/updateCalendar";
export const COMPANIES_WITHOUT_SUBSCRIPTION = "company/companiesWithoutSubscription";
export const COMPANY_CONFIG = "company/config";
export const FETCH_INDUSTRIES_LIST = "company/industries";

// PERFORMANCE
export const FETCH_USER_PERFORMANCE = "kpis/get-user-performance";

// COMPANY ADMIN HOME PAGE AND PERFORMANCE PAGE
export const GET_COMPANY_ADMIN_MANAGER_PERFORMANCE = "kpis/get-company-kpi-performance";
export const GET_MANAGER_PERFORMANCE_FOR_HOME = "kpis/get-manager-team-performance";

// LEADERBOARD
export const GET_LEADERBOARD_DATA = "leaderboard/get-leaderboard-list";
export const GET_TOP_PERFORMERS = "leaderboard/get-top-performers";

// PERMISSION
export const GET_ALL_PERMISSION = "permissionProfiles/get-all-permission";
export const CREATE_PERMISSION_PROFILE = "permissionProfiles/create-permission-profile";
export const GET_PERMISSION_PROFILE_GRANTS = "permissionProfiles/get-permission-profile-grants";
export const EDIT_PERMISSION_PROFILE_GRANTS = "permissionProfiles/edit-permission-profile-grants";
export const GET_PERMISSION_PROFILES = "permissionProfiles/get-permission-profiles";

// LOCATIONS
export const GET_ALL_LOCATIONS = "location/get-location-list";

// COCHUP
export const MYTEAM_REPORTS = "coachup/coachup-reports";
export const REPORTS_ASSIGNED_BY_USER = "coachup/reports-assigned-by";
export const ASSIGNED_TO_ME_REPORTS = "coachup/individual-coachup-reports";
export const NESTED_USER_REPORTS = "coachup/nested-user-reports";
export const USER_REPORT = "coachup/user-coachup-reports";

// COACH UP
export const GET_ALL_TEMPLATES = "coachup/get-template-list";
export const GET_COLORS = "coachup/colors";
export const ADD_TEMPLATE = "coachup/add-new-template";
export const GET_TEMPLATE = "coachup/get-template/";
export const UPDATE_TEMPLATE = "coachup/edit-template/";
export const GET_USER_ALL_TEMPLATE = "coachup/get-user-all-template/";
export const RENAME_TEMPLATE = "coachup/rename-template/";
export const ASSIGN_TEMPLATE = "coachup/assign-user-template/";
export const DELETE_TEMPLATE = "coachup/delete-template/";
export const EDIT_USER_TEMPLATE = "coachup/edit-user-template/";
export const GET_USER_TEMPLATE = "coachup/get-user-template-detail/";
export const GET_ALL_USERS = "coachup/get-all-company-user";
export const ADD_QUESTION_COMMENT = "coachup/question-comment";
export const ADD_REPORT_COMMENT = "coachup/report-comment";
export const ACCEPT_REPORT = "coachup/accept-user-answers";
export const DRAFT_REPORT = "coachup/draft-user-answers";
export const SUBMIT_REPORT = "coachup/submit-user-answers";
export const GET_USER_REPORTS = "coachup/user-reports-to";
export const GET_RECURRENCE_TYPES = "coachup/recurrence-type";
export const GENERATE_REPORT = "coachup/generate-report";

// COMPETE
export const GET_COMPETITION_BADGES = "competition/get-badges";
export const GET_COMPETITION_WIN_CONDITIONS = "competition/get-competition-win-condition";
export const GET_COMPETITION_TYPES = "competition/get-competition-types";
export const ADD_COMPETITION = "competition/add-competition";
export const GET_INPUT_KPI_USERS = "competition/get-user-permission-based";
export const GET_COMPETITIONS = "competition/get-user-competition-list";
export const DELETE_COMPETITION = "competition/delete-competition/";
export const GET_COMPETITION = "competition/get-competition/";
export const UPDATE_COMPETITION = "competition/update-competition/";
export const COMPETITION_ASSIGN_USERS = "competition/assign-user-competition";
export const END_COMPETITION = "competition/close-competition-list";
export const ACTIVATE_COMPETITION = "competition/active-competition";
export const GET_COMPETITIONS_WIDGET_DATA = "competition/get-user-widget-detail";
export const GET_USER_COMPETITION_BY_STATUS = "competition/get-user-competition-by-status";
export const GET_COMPETITION_USER_LIST = "competition/get-competition-member-list";
export const GET_COMPETITIONS_ON_HOME = "competition/get-user-competition-data";
export const JOIN_COMPETITION = "competition/join-competition";
export const UPDATE_COMPETITION_ACTIVITY = "competition/update-competition-kpi";
export const RE_RUN_COMPETITION = "competition/re-run-competition";
export const GET_CAMPAIGNS = "competition/get-tremendous-campaigns";
export const REMOVE_COMPETITION_FROM_FAVORITES = "competition/remove-competition-from-favorites/";

// Cache
export const FLUSH_CACHE = "cache/flush";
export const FETCH_CACHE = "cache";

// Crons
export const CRONS = "crons";
export const PAUSE_CRON = "crons/pause";
export const UNPAUSE_CRON = "crons/unpause";

// Integration Events
export const INTEGRATION_EVENTS = "integrationEvent/getReport";

// Modules
export const GET_COMPANIES_ENABLED_MODULES = "module/getCompaniesEnabledModules";
export const GET_COMPANY_AND_MODULE_LISTS = "module/getCompanyAndModuleLists";
export const COMPANY_ENABLED_MODULE = "module/companyEnabledModule";
export const GET_MODULES = "module/getUserModules";
export const MODULES = {
  SALES_COACHING: "Coaching",
  COMPETITIONS: "Compete",
  LEADERBOARD: "Leaderboard",
  INTEGRATIONS: "Integrations",
  PERFORMANCE_ANALYTICS: "PerformanceAnalytics",
  ALYS: "Alys",
  INSIGHTS: "Insights",
};
export const COMPONENTS = {
  LEADERBOARD: {
    ROLE_VIEWS: "RoleViews",
  },
  COMPETITIONS: {
    NOTIFICATIONS: "Notifications",
    REWARDS: "Rewards",
  },
};

// App Settings
export const GET_APP_SETTINGS = "settings/system";
export const GET_APP_DETAILED_SETTINGS = "settings/system/detailed";
export const GET_QUOTA_SETTINGS = "settings/quota";

// Integrations
export const UPDATE_INTEGRATION_SETTINGS = "integration";
export const GET_INTEGRATION_SETTINGS = "integration";
export const DELETE_INTEGRATION = "integration";
export const RESYNC_MAPPING_SETTING = "integration/resync-mapping";

// OAuth
export const INTEGRATION_TRADE_CODE_FOR_AUTHORIZATION = "oauth/cb";

export const VERIFY_MODULE = "module/verify";

// CONFIG NAMES
export const CONFIG_NAME = {
  FISCAL_YEAR_START: "FISCAL_YEAR_START",
  WORKING_DAYS: "WORKING_DAYS",
};

// PERMISSION NAMES
export const PERMISSIONS_NAME = {
  MANAGE_USERS: "manage_users",
  MANAGE_KPIS: "manage_kpis",
  INPUT_KPIS: "input_kpis",
  MANAGE_COACHUP: "manage_coachup",
  MANAGE_WORKSPACE: "manage_workspace",
  COMPETE_UNRANKED: "compete_unranked",
  COMPETE_TREMENDOUS_PAYOUT: "compete_tremendous_payout",
  MANAGE_INTEGRATION_SETTINGS: "manage_company_integration_settings",
  ADMIN: "admin",
  MANAGE_INSIGHTS: "manage_insights",
};
// USER TYPES
export const USER_TYPES = {
  ADMIN: "admin",
  USER: "user",
};
// RECURRENCE TYPES
export const RECURRENCE_TYPES = {
  NO_RECURRENCE: "no_recurrence",
  WEEKLY: "weekly",
  MONTHLY: "monthly",
  QUARTERLY: "quarterly",
  ANNUALLY: "annually",
};

export const COACHUP_QUESTION_TYPES = {
  BOOLEAN: "true/false",
  TEXT: "text",
  PIPELINE_HEALTH: "pipeline health",
  NUMBER: "number",
  CURRENCY: "currency",
  ASSESSMENT: "assessment",
};
export const DATE_FILTER_OPTIONS = [
  "Today",
  "This Week",
  "Last Week",
  "This Month",
  "Last 30 days",
  "Last Month",
  "Last 60 days",
  "This Quarter",
  "Last Quarter",
  "This Year",
  "Last Year",
  "Custom",
];

export const PERFORMANCE_ANALYTICS_OPTIONS = ["Week", "Month", "Quarter", "Year"];

export const CONVERSION_FUNNEL_DATE_FILTER_OPTIONS = [
  "Today",
  "This Week",
  "Last Week",
  "This Month",
  "Last 30 days",
  "Last Month",
  "Last 60 days",
  "This Quarter",
  "Last Quarter",
  "This Year",
  "Last Year",
];

export const COMPETITION_WIN_CONDITIONS = {
  TOTAL_KPIS: "Total KPIs",
  TOTAL_POINTS: "Total Points",
  FIRST_TO_KPI_TARGET: "First To KPI Target",
};

// Reporting
export const REPORT_FRONTEND_ERROR = "frontendReporting/error";

// Workspace
export const COMPANY_LIST_FROM_DOMAIN = "company/companyListFromDomain";
export const REGISTER_WORKSPACE_URL = "user/workspace/register";
export const JOIN_EXISTING_WORKSPACE_URL = "user/workspace/join";
export const JOIN_INVITED_USER_TO_WORKSPACE_URL = "user/workspace/joinInvitedUser";
export const DECLINE_INVITE_USER_TO_WORKSPACE_REQUEST_URL =
  "user/workspace/declineInviteUserToWorkspaceRequest";
export const WORKSPACE_DROPDOWN_LISTS = "user/workspace/dropdownLists";
export const GET_USER_WORKSPACES = "user/workspace/list";
export const SWITCH_USER_WORKSPACE = "user/workspace/switch";
export const USER_INVITATION = "user-invitation";

// Pending Users
export const PENDING_USERS = "user/pendingUsers";
export const RESEND_INVITATION = "user/resendInvitation";
export const PENDING_CONFIRMATION = "pending_confirmation";
export const INVITE_SENT = "invite_sent";
export const ACTIVE = "active";
export const TEAM_FROM_VALID_INVITE = "user/team-from-valid-invite";

// Colors
export const THEMES = {
  PRIMARY: {
    TEXT_DARK: "#000000",
    TEXT_LIGHT: "#FFFFFF",
    TEXT_WIDGET: "#344767",
    BLACK: "#19191B",
    BLUE: "#8BA5CE",
    BLUE_ICON: "#448cff",
    RED: "#F83A46",
    RED_TREND: "#e23a3a",
    GREEN_TREND: "#02c295",
    RED_SECONDARY: "#ff2c56",
    // GREEN: "#00b168",
    GREEN: "#02c295",
    GRAY: {
      20: "#CECECE",
      40: "#989797",
      60: "#6F6E6E",
      80: "#272727",
    },
  },
};

// Widgets
export const GET_WIDGET_DASHBOARD_LAYOUT = "user/getWidgetDashboardLayout";
export const GET_WIDGET_DEFINITIONS = "user/getWidgetDefinitions";
export const UPDATE_WIDGET_DASHBOARD_LAYOUT = "user/saveWidgetDashboardLayout";
export const DELETE_WIDGET_DASHBOARD_FOR_USER = "user/deleteUserWidgetDashboard";
export const DELETE_WIDGET_DASHBOARD_FOR_COMPANY = "user/deleteCompanyWidgetDashboard";
export const GET_LEADERBOARD_SELECTION_OPTIONS = "user/getLeaderboardSelectionOptions";
export const GET_KPI_SELECTION_OPTIONS = "user/getKpiSelectionOptions";

// Chatbot
export const GET_CHATBOT_DATA = "company/getChatbotData";

// Communication Hub
export const GET_ALL_HUB_CONTENT = "hub";
export const GET_WIN_WIRE_MESSAGES = "hub/get-win-wire-messages";
export const ADD_WIN_WIRE_REACTION = "hub/add-reaction";
export const REMOVE_WIN_WIRE_REACTION = "hub/remove-reaction";
export const REMOVE_WIN_WIRE_REPLY = "hub/remove-reply";
export const SEND_WIN_WIRE_REPLY = "hub/send-reply";
export const EDIT_WIN_WIRE_REPLY = "hub/edit-reply";
export const INSIGHT_NOTIFICATIONS = "hub/insight-notifications";
export const REMOVE_HUB_NOTIFICATIONS = "hub/remove-notifications";
export const INCREMENT_NOTIFICATION = "hub/increment-notification";
export const MUTE_INSIGHT = "hub/mute-insight";
export const GET_HUB_SETTINGS = "hub/settings";

// ALYS
export const GET_CHAT_CONVERSATIONS = "aiConversations";
export const ASK_ALYS = "aiConversations/question";
export const DELETE_ALYS_CONVERSATION = "aiConversations";
export const GET_CHAT_PREPOPULATED_QUESTIONS = "aiConversations/prepopulated-questions";
export const GET_CHAT_PREPOPULATED_QUESTION_OPTIONS =
  "aiConversations/prepopulated-question-options";
export const SEND_MESSAGE_RATING = "aiConversations/rate-thread";
export const GET_QUERY_OPTIONS = "aiConversations/query-options";
export const UPDATE_ALYS_OPTIONS = "aiConversations/store-options";

// outOfOffice
export const FETCH_ALL_OUT_OF_OFFICE_DAYS = "outOfOffice/allDays";
export const FETCH_FUTURE_OUT_OF_OFFICE_DAYS = "outOfOffice/futureDays";
export const CREATE_OUT_OF_OFFICE_DAYS = "outOfOffice/create";
export const CREATE_OUT_OF_OFFICE_DAYS_FOR_REPORTS_TO_USERS = "outOfOffice/create/reportToUsers";
export const EDIT_OUT_OF_OFFICE_DAYS_FOR_REPORTS_TO_USERS = "outOfOffice/edit/reportToUsers";
export const DELETE_OUT_OF_OFFICE_DAYS = "outOfOffice";

// company Holidays
export const CREATE_COMPANY_HOLIDAYS = "companyHolidays/create";
export const EDIT_COMPANY_HOLIDAYS = "companyHolidays/edit";
export const TOGGLE_COMPANY_HOLIDAYS = "companyHolidays/toggle";
export const COMPANY_HOLIDAYS = "companyHolidays";
